import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "motion/react";
import ChevronDown from "@/assets/svg/chevronDown.svg";

const CollapsibleSectionContainerOuter = styled.div`
  border: 1px solid #e2e2e2;
  padding: 0 0 16px 0;
  border-left: 0;
  border-right: 0;
  border-top: 0;
`;

const LabelSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

const Label = styled.div`
  font-feature-settings:
    "ss11" on,
    "liga" off,
    "calt" off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.01rem;
  color: 727279;
`;

const IconContainer = styled(motion.div)`
  width: 20px;
  height: 20px;
  color: #727279;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 100%;
    height: 100%;
  }
`;

const ContentOuterContainer = styled(motion.div)`
  width: 100%;
  height: 0;
  overflow: hidden;
`;

const ContentInnerContainer = styled.div`
  width: 100%;
  height: auto;
`;

const anim = {
  hidden: {
    height: 0,
    transition: {
      duration: 0.65,
      ease: [0.87, 0, 0.13, 1],
      type: "tween",
    },
  },
  visible: {
    height: "auto",
    transition: {
      duration: 0.55,
      ease: [0.87, 0, 0.13, 1],
      type: "tween",
    },
  },
};

export default function CollapsibleSection({
  label,
  isDefaultOpen,
  hasCustomState,
  isCustomOpen,
  setIsCustomOpen,
  children,
}: {
  label: string;
  isDefaultOpen?: boolean;
  hasCustomState?: boolean;
  isCustomOpen?: boolean;
  setIsCustomOpen?: (isOpen: boolean) => void;
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(isDefaultOpen || false);
  return (
    <CollapsibleSectionContainerOuter>
      <LabelSection
        onClick={() => {
          if (hasCustomState) {
            setIsCustomOpen && setIsCustomOpen(!isCustomOpen);
          } else {
            setIsOpen(!isOpen);
          }
        }}>
        <Label>{label}</Label>
        <IconContainer animate={{ rotate: hasCustomState ? (isCustomOpen ? -180 : 0) : isOpen ? -180 : 0 }}>
          <ChevronDown />
        </IconContainer>
      </LabelSection>
      <ContentOuterContainer
        variants={anim as any}
        animate={hasCustomState ? (isCustomOpen ? "visible" : "hidden") : isOpen ? "visible" : "hidden"}
        initial={hasCustomState ? (isCustomOpen ? "visible" : "hidden") : isOpen ? "visible" : "hidden"}>
        <ContentInnerContainer>{children}</ContentInnerContainer>
      </ContentOuterContainer>
    </CollapsibleSectionContainerOuter>
  );
}
